import { render } from "./PromptDialog.vue?vue&type=template&id=bd595a0e&scoped=true"
import script from "./PromptDialog.vue?vue&type=script&lang=js"
export * from "./PromptDialog.vue?vue&type=script&lang=js"

import "./PromptDialog.vue?vue&type=style&index=0&id=bd595a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd595a0e"]])

export default __exports__